export enum MapperType {
  Constant = "constant",
  Field = "field"
}

export type ConstantMapper = {
  type: MapperType.Constant
  value: string
}
export type FieldMapper = {
  type: MapperType.Field
  value: string
}
export type TypeSafeMapper = ConstantMapper | FieldMapper

export type LDAPServerInfo = {
  name: string
  queryTemplate: string
  userInfoMapper: {
    email: TypeSafeMapper
    employeeId: TypeSafeMapper
    fullName: TypeSafeMapper
    title: TypeSafeMapper
  }
}